module.exports = __webpack_public_path__ + "media/ab-homepage/illhandwrit-19e8b05a.png";